import { DataImage } from 'app/interfaces/DataImage';
import { DicomData } from 'app/interfaces/Dicom';
import { DisplayableImageData } from 'app/interfaces/Image';

export class DicomBlob extends Blob {}

export type Base64Image = `data:image/${string}`;
export type ImagePath = { path: string; isFromFileSystem?: boolean };
export type LoadableImageFile = File | Base64Image | ImagePath | DataImage | DicomBlob;

export type LoadedImage = {
  imageData: DisplayableImageData;
  dicomData?: DicomData;
  filename?: string;
  processedImage?: DataImage;
  // Special case for image that we known as already processed and no additional processing should be done
  // Kind of a stopgag for PACS image, but I don't have anything better
  isNotProcessable?: boolean;
};

export interface ImageLoader {
  load: (imageFile: LoadableImageFile) => Promise<LoadedImage>;
}
